export const downloadBlob = (data, filename) => {
  const url = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const downloadErrorMessage = async (error, fallback) => {
  let data = error.response?.data;
  if (data instanceof Blob) {
    try { data = JSON.parse(await data.text()); } catch { return fallback; }
  }
  if (data?.detail) return data.detail;
  const messages = data && typeof data === "object" ? Object.values(data).flat() : [];
  return messages.length ? messages.join(" ") : fallback;
};
